export default {
  lychen: {
    phonetic: '\\li. kɛn\\',
    copyright: '© 2024 lychen, all rights reserved',
  },
};
